<template>
  <div class="app-container">
    <goods-type ref="goodsType" />
  </div>
</template>
<script>
import goodsType from "@/components/goods/type/index";

export default {
  name: "type",
  components: {
    goodsType,
  },
  methods: {},
};
</script>